module.exports = __webpack_public_path__ + "img/sixpackcarrier56.78f98ee2.jpg";